import { render, staticRenderFns } from "./OptionEditor.vue?vue&type=template&id=b023adac&scoped=true"
import script from "./OptionEditor.vue?vue&type=script&lang=js"
export * from "./OptionEditor.vue?vue&type=script&lang=js"
import style0 from "./OptionEditor.vue?vue&type=style&index=0&id=b023adac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b023adac",
  null
  
)

export default component.exports